import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { AutomakerDto } from 'src/app/shared/models/automaker/automaker-dto';
import { AutomakerService } from 'src/app/shared/services/automaker/automaker.service';
import { Alert, AlertService, ModalComponent, ModalResult } from '@michelin/theme';
import { AuthService } from 'src/app/shared/services/auth/auth.service';

@Component({
    selector: 'app-automaker-select-modal',
    templateUrl: './automaker-select-modal.component.html',
    styleUrls: ['./automaker-select-modal.component.scss'],
    standalone: false
})
export class AutomakerSelectModalComponent implements OnInit {
  loading = false;
  automakers: AutomakerDto[] = [];
  userAutomaker: number | null = null;

  form: FormGroup;

  @Output() selectedAutomakerId = new EventEmitter<number | null>();

  @ViewChild('modal') modal: ModalComponent;
  @ViewChild('modalContent') modalContent: TemplateRef<any>;

  constructor(
    private readonly authService: AuthService,
    private readonly automakerService: AutomakerService,
    private readonly alertService: AlertService,
    private readonly fb: FormBuilder
  ) {
    this.form = this.fb.group({ automaker: [''] });
  }

  ngOnInit(): void {
    this.loadAutomakers();
  }

  open() {
    this.form.reset();
    this.modal.open({
      id: 'automakerSelectModal',
      title: 'Selecionar Montadora',
      width: 500,
      content: this.modalContent,
      confirm: 'Exportar',
      cancel: 'Cancelar'
    });
  }

  onModalClosed(result: ModalResult) {
    if (result.result) {
      const selected: AutomakerDto | null = this.form.value.automaker || null;
      this.selectedAutomakerId.emit(selected?.company?.id || null);
    }
  }

  loadAutomakers() {
    const user = this.authService.getUserData();
    this.loading = true;
    this.automakerService
      .findAll()
      .subscribe({
        next: (items) => {
          if (user?.userProfile?.userType === 'AUTOMAKER' && user?.company) {
            this.automakers = items.filter((d) => d.company?.id === user.company?.id);
          } else {
            this.automakers = items;
          }
        },
        error: () =>
          this.alertService.showAlert({ type: 'critical', title: 'Erro ao carregar automakers' } as Alert)
      })
      .add(() => (this.loading = false));
  }

  displayName(a: AutomakerDto): string {
    return a?.company?.tradeName || a?.code || `#${a.id}`;
  }

  get automaker(): FormControl {
    return this.form.get('automaker') as FormControl;
  }
}
